(function ($) {
    $(document).ready(function () {

        const section = $(".section-faq");
        let canClick = true;

        section.find(".item .question").on("click", (e) => {
            if (!canClick) {
                return
            }

            canClick = false;
            $(e.currentTarget).toggleClass("active").parent().find(".answer").slideToggle(300);
            setTimeout(() => canClick = true, 300);
        });

    })
})(jQuery);